import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private current?: Notification;

  // tag: dient zur Unterscheidung der Notification (für close)
  async show(tag: string, title: string, url: string, options?: NotificationOptions) {
    // Berechtigung prüfen
    const hasPermission = await this.askPermission();
    if (!hasPermission) {
      return;
    }

    // Fontend Notification (Desktop Browser)
    if (Notification.permission === 'granted' && !navigator.serviceWorker.controller) {
      this.current = new Notification(title, options);
      this.current.onclick = (event) => {
        window.focus();  // existierenden Tab in den Vordergrund holen
        window.open('/', '_blank'); // oder neuen Tab öffnen:
      };
      // funktioniert nicht zuverlässig
      this.current.onclose = () => {
        this.current = undefined;
      };
      return;
    }

    // Service Worker Notification (Mobile Browser)
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      await registration.showNotification(title, {
        ...options,
        tag,
        data: {
          // https://angular.dev/ecosystem/service-workers/push-notifications#notification-payload
          onActionClick: {
            default: {
              operation: "navigateLastFocusedOrOpen",
              url
            }
          }
        }
      });
    }
  }

  async close(tag: string) {
    // Frontend Notification
    this.current?.close();
    this.current = undefined;

    // Service Worker Notification
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      registration.getNotifications({ tag }).then((notifications) => {
        notifications.forEach((notification) => notification.close());
      });
    }
  }

  async isOpen(tag: string) {
    // Frontend Notification
    if (this.current) {
      return true;
    }

    // Service Worker Notification
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      const notifications = await registration.getNotifications({ tag });
      return notifications.length > 0;
    }
  }

  async askPermission(): Promise<boolean> {
    // Kein Support für Notifications
    if (!('Notification' in window)) {
      return false;
    }

    // Berechtigung schon erteilt?
    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission === 'denied') {
      return false;
    }

    const permission = await Notification.requestPermission();
    return permission === 'granted';
    //  Falls Permission denied, evtl. Meldung anzeigen:
    // "Benachrichtigungen wurden blockiert. Bitte aktivieren Sie sie in den Website-Einstellungen Ihres Browsers."
  }

}